var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FullCalendar',{attrs:{"defaultView":"dayGridMonth","datesRender":_vm.datesRender,"defaultDate":_vm.defaultDate,"events":_vm.events,"eventRender":_vm.eventRender,"header":_vm.header,"height":550,"locale":_vm.ptbr,"plugins":_vm.plugins,"themeSystem":'bootstrap',"weekends":true},on:{"dateClick":_vm.dayClick,"eventClick":_vm.titleClick}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-450e5b2a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/calendar.vue
// module id = null
// module chunks = 